// extracted by mini-css-extract-plugin
export default {"success":"Result_success__4RMh1","failure":"Result_failure__LsSDr","hash":"Result_hash__eQcFI","feedback":"Result_feedback__5q3Lo"};